import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5522%3A1480
 *
 * @param {SvgIconProps} props - svg props
 */
export const VisibilityIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12 6C8.02273 6 4.62614 8.488 3.25 12C4.62614 15.512 8.02273 18 12 18C15.9773 18 19.3739 15.512 20.75 12C19.3739 8.488 15.9773 6 12 6ZM12 16C9.80455 16 8.02273 14.208 8.02273 12C8.02273 9.792 9.80455 8 12 8C14.1955 8 15.9773 9.792 15.9773 12C15.9773 14.208 14.1955 16 12 16ZM12 9.6C10.6795 9.6 9.61364 10.672 9.61364 12C9.61364 13.328 10.6795 14.4 12 14.4C13.3205 14.4 14.3864 13.328 14.3864 12C14.3864 10.672 13.3205 9.6 12 9.6Z' fill={color}/>
        </SvgIcon>
    )
}

export default VisibilityIcon
